function Input({ id, label, type, value, onInput, onChange }) {
    return (
        <div class="form-floating  mb-3">
            <input class="form-control" id={id} type={type} name={id} value={value} onInput={onInput} onChange={onChange} />
            <label class="form-label" for={id}>{label}</label>
        </div>
    )
}

export default Input;